import styled from "styled-components";

export const MobileNav = styled.div`
  flex-basis: 100%;
  background-color: #fff;
  position: absolute;
  top: 90px;
  left: 20px;
  right: 20px;
  z-index: 10;

  ul {
    display: flex;
    flex-direction: column;
    color: #2D2D2D;
    list-style: none;

    & li {
      display: flex;
    }

    & a {
      flex-basis: 100%;
      text-transform: uppercase;
      text-decoration: none;
      padding: 30px 20px;

      &.active {
        color: #fff;
        background-color: ${({theme}) => theme.colors.primaryLight}
      }

      &:hover {
        cursor: pointer;
      }
      &:not(.active):hover {
        text-decoration: underline;
      }

    }
  }
`;